export default __webpack_public_path__ + "static/media/solar_user-outline.5a645f9c.svg";